import { PlusShopLandingPage } from './PlusShopLanding.page';

export const plusShopLandingRouter = {
  '/@/plus': PlusShopLandingPage,
};
